<div class="myRequests otPropTable">
    <div class="main-div-with-white-bkg no-border-bkg padding">
        <div class="row no-padding">
            <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12">
              <div class="global-tab">
                <mat-tab-group #matTabs color="transparent" [(selectedIndex)]="selectedIndex"
                (selectedTabChange)="onMatChange($event, selectedIndex)"
                  preserveContent = "disableSearch">
                  <mat-tab>
                    <ng-template mat-tab-label>
                      <span *ngIf="selectedIndex == 0; else inactiveLogo">
                        <img class="img-width-height" src="assets/workqueuesLogos/open.png"/>
                      </span>
                      <ng-template #inactiveLogo>
                        <img class="img-width-height" src="assets/workqueuesLogos/open2.png"/>
                      </ng-template>
                      &nbsp; Open 
                      &nbsp; {{ openRequestsCount }} 
                    </ng-template>
                    <ng-template matTabContent>
                        <app-prop-table [selectedOption]="'approvals'" [columns]="openColumns" [inputDataSource]="tableDataSource" (reloadDataEvent)="reloadData()" [requestStatus]="'Open'"  (statusChangeEvent)="updateTableContent($event)" [receivedData]="receivedData"></app-prop-table>
                    </ng-template>
                  </mat-tab>
                  <mat-tab>
                    <ng-template mat-tab-label>
                      <span *ngIf="selectedIndex == 1; else inactiveLogo">
                        <img class="img-width-height" src="assets/workqueuesLogos/completed-active.png"/>
                      </span>
                      <ng-template #inactiveLogo>
                        <img class="img-width-height" src="assets/workqueuesLogos/completed-inactive.png"/>
                      </ng-template>
                      &nbsp; Approved
                      &nbsp; {{ completedRequestsCount }} 
                    </ng-template>
                    <ng-template matTabContent>
                        <app-prop-table [selectedOption]="'approvals'" [columns]="approvedColumns" [inputDataSource]="tableDataSource" [requestStatus]="'Approved'" [receivedData]="receivedData"></app-prop-table>
                    </ng-template>
                  </mat-tab>
                  <mat-tab>
                    <ng-template mat-tab-label>
                      <span *ngIf="selectedIndex == 2; else inactiveLogo">
                        <img class="img-width-height special-icon" src="assets/workqueuesLogos/rejected_active.png"/>
                      </span>
                      <ng-template #inactiveLogo>
                        <img class="img-width-height special-icon" src="assets/workqueuesLogos/rejected_inactive.png"/>
                      </ng-template>
                      &nbsp; Rejected 
                      &nbsp; {{ rejectedRequestsCount }} 
                    </ng-template>
                    <ng-template matTabContent>
                        <app-prop-table [selectedOption]="'approvals'" [columns]="rejectedColumns" [inputDataSource]="tableDataSource" [requestStatus]="'Rejected'" [receivedData]="receivedData"></app-prop-table>
                    </ng-template>
                  </mat-tab>
                  <mat-tab>
                    <ng-template mat-tab-label>
                      <span *ngIf="selectedIndex == 3; else inactiveLogo">
                        <img class="img-width-height" src="assets/workqueuesLogos/cancelled-active.png"/>
                      </span>
                      <ng-template #inactiveLogo>
                        <img class="img-width-height" src="assets/workqueuesLogos/cancelled-inactive.png"/>
                      </ng-template>
                      &nbsp; Cancelled 
                      &nbsp; {{ cancelledRequestsCount }} 
                    </ng-template>
                    <ng-template matTabContent>
                        <app-prop-table [selectedOption]="'approvals'" [columns]="cancelledColumns" [inputDataSource]="tableDataSource" [requestStatus]="'Cancelled'" [receivedData]="receivedData"></app-prop-table>
                    </ng-template>
                  </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>
    
</div>